<template>
  <div id="list" class="view-container">
    <BottomBar />
    <div v-if="!data">
      <Empty
        :loading="isLoading"
        :error="error"
        :icon="true"
        title="暂无作业"
        subtitle="平台会在课后布置作业"
      />
    </div>
    <div v-else>
      <Tab v-model="active" :options="tabOptions" title="课后作业" back="/schedule" />
      <main v-show="active === tabOptions[0]" class="tab-view-container padding-y items">
        <Item
          v-for="item in homework"
          :key="item.id"
          :data="item"
          :schedule="schedule.find(s => s.id === item.schedule_time.s_id)"
          :teacher="teacher.find(t => item.schedule_time.t_id === t.t_id)"
        />
      </main>
      <WeekList
        v-show="active === tabOptions[1]"
        :homework="homework"
        :schedule="schedule"
        :teacher="teacher"
      />
    </div>
  </div>
</template>
<script>
import Empty from "../public/Empty"
import Item from "./Item"
import BottomBar from "@/components/public/footer"
import Tab from "@/components/public/Tab"
import WeekList from "./week/List"

export default {
  name: "HomeworkList",
  components: {
    Empty,
    Item,
    BottomBar,
    Tab,
    WeekList
  },
  data() {
    return {
      data: undefined,
      isLoading: true,
      error: null,
      // Tab
      tabOptions: ["所有", "周报"],
      active: ""
    }
  },
  computed: {
    homework() {
      if (!this.data) return []
      return this.data.homework
    },
    teacher() {
      if (!this.data) return []
      return this.data.teacher
    },
    schedule() {
      if (!this.data) return []
      return this.data.schedule
    },
  },
  created() {
    this.active = this.tabOptions[0]
  },
  activated() {
    this.wechatInit()
    this.getData()
  },
  methods: {
    wechatInit() {
      this.$wxShare({
        title: "课后作业 - AnyTeach",
        imgUrl: window.logo2019,
        desc: "点击查看你的课后作业，记得按时完成！",
        link: window.homePageUrl + this.$route.fullPath,
      })
    },
    async getData() {
      try {
        const { code, msg } = await this.$api.homework.LIST()
        this.isLoading = false
        if (code === "1000") {
          this.data = msg
        } else {
          this.data = false
        }
      } catch (error) {
        this.isLoading = false
        this.error = error.message
      }
    },
  },
}
</script>
<style scoped lang="scss">
@import "./style.scss";
@import "@/assets/css/scaffold.scss";
</style>
